
import { NSToolDraw } from './tool_draw';
import {fromLonLat} from 'ol/proj';
import { Map as NSMap } from './map';
import {xCore} from './core';
import SendIcon from 'bootstrap-icons/icons/send-fill.svg?raw';

export let NSSearchCoordinatesToolbar = {}

NSSearchCoordinatesToolbar.init = function() {
    NSToolbarPrivate.init();

    this.f_open = function () { return NSToolbarPrivate.f_open.apply( NSToolbarPrivate, arguments ); };
    this.f_close = function () { return NSToolbarPrivate.f_close.apply( NSToolbarPrivate, arguments ); };
    this.f_toggle = function () { return NSToolbarPrivate.f_toggle.apply( NSToolbarPrivate, arguments ); };
}

let NSToolbarPrivate = 
{
    init: function() {
        this.element = document.createElement("div");
        this.element.setAttribute("id", "search-coordinates-toolbar");
        this.element.classList.add('closed');

        this.element.innerHTML = `
            <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm" placeholder="Latitude" data-key="latitude">
                <input type="text" class="form-control form-control-sm" placeholder="Longitude" data-key="longitude">
                <button type="button" class="btn btn-danger">
                    ${SendIcon}
                </button>
            </div>
        `;

        this.element.querySelector('button').onclick = () => {
            let latitude = parseFloat(this.element.querySelector('input[data-key="latitude"').value);
            let longitude = parseFloat(this.element.querySelector('input[data-key="longitude"').value);

            if (typeof latitude != 'number' || isNaN(latitude)) return;
            if (typeof longitude != 'number' || isNaN(longitude)) return;

            let a_coordinates = fromLonLat([longitude, latitude]);

            NSToolDraw.f_draw_marker_enable({
                type: "Point",
                coordinates: a_coordinates
            });
            
            NSMap.f_get_map().getView().setCenter(a_coordinates);
        }

        document.body.appendChild(this.element);
    },
    f_open: function() {
        this.element.classList.add('open');
        this.element.classList.remove('closed');
    },
    f_close: function() {
        this.element.classList.add('closed');
        this.element.classList.remove('open');
    },
    f_toggle: function() {
        return this.f_is_closed() ? this.open() : this.closed();
    },
    f_is_closed: function() {
        return this.element.classList.contains('closed');
    },
    f_is_open: function() {
        return this.element.classList.contains('open');
    }
}
	
